<script lang="ts">
import { LANG_TH } from "@/app/const";
import { flagByLanguage } from "@/app/locales/flags";
import { useLangStore } from "@/store/lang";

export default {
  setup() {
    const langStore = useLangStore();
    return { langStore };
  },
  data() {
    return {
      languages: flagByLanguage,
      text: "",
      flag: "",
      value: null,
      lan: "",
      toggle_exclusive: LANG_TH,
    };
  },
  mounted() {
    let data = undefined as any;
    if (this.langStore.getData()) {
      this.toggle_exclusive = this.langStore.getData();
      data = this.languages.find(o => o.language === this.langStore.getData())
    } else {
      data = this.languages.find(o => o.language === this.toggle_exclusive)
    }
    this.setLang(data);
  },
  methods: {
    setLang(data: any) {
      if (data) this.setLanguage(data);
    },
    setLanguage(entry: { language: string; title: string; flag: string }) {
      const { language: locale, title: country, flag } = entry;
      this.lan = locale;
      this.text = country;
      this.flag = flag;

      const element = document.getElementById("header-lang-img");
      if (element) {
        element.setAttribute("src", flag);
      }
      this.langStore.setData(locale);
      this.$i18n.locale = locale;
    },
  },
};
</script>
<template>
  <v-btn-toggle class="language-toggle" v-model="toggle_exclusive" mandatory
    @update:model-value="setLang(languages.find(o => o.language === toggle_exclusive))" rounded>
    <v-btn value="th"> ไทย </v-btn>
    <v-btn value="en"> ENG </v-btn>
  </v-btn-toggle>
  <v-menu>
    <!-- <template v-slot:activator="{ props }">
      <v-btn variant="text" dark v-bind="props" icon>
        <img
          id="header-lang-img"
          src="@/assets/images/flags/th.svg"
          alt="Header Language"
          height="20"
          class="rounded"
        />
      </v-btn>
    </template> -->
    <!-- <v-list width="145" density="compact" :lines="false">
      <v-list-item
        v-for="(entry, i) in languages"
        :key="`Lang${i}`"
        class="dropdown-item notify-item language pa-0"
        @click="setLanguage(entry)"
      >
        <v-row no-gutters class="py-0 px-3">
          <v-col cols="3">
            <img
              :src="entry.flag"
              alt="user-image"
              class="me-2 rounded"
              height="18"
            />
          </v-col>
          <v-col cols="9">
            <v-list-item-title class="d-flex">{{
              entry.title
            }}</v-list-item-title>
          </v-col>
        </v-row>
      </v-list-item>
    </v-list> -->
  </v-menu>
</template>
